var React = require('react');

function HeaderOverlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"overlay","d":"M458-672.1C63.67-467.67-820.48-453.93-820.48-453.93l1278.4-.17Z","transform":"translate(820.49 672.92)"}));
}

HeaderOverlay.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 1278.95 219.49","aria-hidden":"true"};

module.exports = HeaderOverlay;

HeaderOverlay.default = HeaderOverlay;
